import Vue from 'vue'
import Toasted from 'vue-toasted'
const config = {
    position: 'top-center',
    iconPack: 'fontawesome', // ['material', 'fontawesome', 'mdi', 'custom-class', 'callback']
    keepOnHover: true,
    singleton: true,
    duration: 1400,
    register: [
        // Register custom toasts
        {
            name: 'saving',
            message: 'Sauvegarde en cours...',
            options: {
                type: 'show',
                duration: 400,
            },
        },
        {
            name: 'exporting',
            message: 'Exportation en cours...',
            options: {
                type: 'show',
                duration: null,
            },
        },
        {
            name: 'exportingError',
            message:
                'Exportation impossible pour le moment. Veuillez réessayer plus tard.',
            options: {
                type: 'error',
                duration: 5000,
                action: [
                    {
                        icon: 'times-circle',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                        },
                    },
                ],
            },
        },
        {
            name: 'exported',
            message: 'Fichier prêt.',
            options: {
                type: 'success',
                duration: 2000,
            },
        },
        {
            name: 'import',
            message: 'Importation en cours...',
            options: {
                type: 'show',
                duration: 400,
            },
        },
        {
            name: 'imported',
            message: 'Sondage importés.',
            options: {
                type: 'success',
                duration: 1200,
            },
        },
        {
            name: 'saved',
            message: 'Changement(s) sauvegardé(s).',
            options: {
                type: 'success',
                duration: 1200,
            },
        },
        {
            name: 'savingError',
            message: "Erreur d'enregistrement.",
            options: {
                type: 'error',
                duration: 5000,
                action: [
                    {
                        icon: 'times-circle',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                        },
                    },
                ],
            },
        },
        {
            name: 'deleting',
            message: 'Suppression en cours...',
            options: {
                type: 'show',
                duration: 400,
            },
        },
        {
            name: 'deleted',
            message: 'Élément correctement supprimé ',
            options: {
                type: 'success',
                duration: 1200,
            },
        },
        {
            name: 'deleteError',
            message: 'Erreur lors de la suppression.',
            options: {
                type: 'error',
                duration: 5000,
                action: [
                    {
                        icon: 'times-circle',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                        },
                    },
                ],
            },
        },
    ],
}
Vue.use(Toasted, config)

config.register.forEach((toast) => {
    Vue.toasted.register(toast.name, toast.message, toast.options)
})

export default Vue
